import { VictoryPointDataChit, VictoryPointDataCity, VictoryPointDataDefenderOfColonist, VictoryPointDataDevelopmentCard, VictoryPointDataLargestArmy, VictoryPointDataLongestRoad, VictoryPointDataMerchant, VictoryPointDataMetropolis, VictoryPointDataProgressCard, VictoryPointDataSettlement } from '@colonist/game-base-types';
export class VictoryPointDataController {
    static getVictoryPointByType(victoryPointType) {
        if (typeof victoryPointType == 'string') victoryPointType = parseInt(victoryPointType, 10);
        return this.typeToData.get(victoryPointType);
    }
}
VictoryPointDataController.victoryPointDataList = [
    new VictoryPointDataSettlement(),
    new VictoryPointDataCity(),
    new VictoryPointDataDevelopmentCard(),
    new VictoryPointDataLargestArmy(),
    new VictoryPointDataLongestRoad(),
    new VictoryPointDataChit(),
    new VictoryPointDataMetropolis(),
    new VictoryPointDataDefenderOfColonist(),
    new VictoryPointDataProgressCard(),
    new VictoryPointDataMerchant()
];
VictoryPointDataController.typeToData = new Map(VictoryPointDataController.victoryPointDataList.map((data)=>[
        data.victoryPointType,
        data
    ]));
